import ActiveClientsModule from "./activeClientsModule";
import ActiveClientsReducer from "./redux/activeClientsReducer";
import ActiveClientsSaga from "./redux/activeClientsSagas";

export default {
  Component: ActiveClientsModule,
  moduleName: "activeClients",
  saga: ActiveClientsSaga(),
  reducer: ActiveClientsReducer
};
